// Keyboard users land on this first; activating it jumps past the header to
// <main>. Hidden visually until focused.
export function SkipLink(): JSX.Element {
  return (
    <a
      href="#main-content"
      className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-50 focus:rounded focus:bg-slate-900 focus:px-4 focus:py-2 focus:text-white"
    >
      Skip to main content
    </a>
  );
}
